import React, {useEffect} from "react";
import {GLOBAL_STYLE_CONFIG} from "../../app/styles/GlobalStyles";

/**
 * Hook useItemsPerRow - будет подписываться на событие изменение размеров containerRef (ширина/высота).
 * и высчитывать кол-во карточек в одной ряду
 *
 * @returns {count: number} - кол-во карточек в одной ряду
 */

function useItemsPerRow(containerRef:  React.RefObject<HTMLDivElement | null> ) {
    const [count, setCount] = React.useState<number>(2);

    useEffect(() => {
        // Observer — это ResizeObserver, который подписан на изменения размера.
        const observer = new ResizeObserver(([entry]) => {
            const container = entry.target; // сам контейнер
            const containerWidth = entry.contentRect.width;

            // находим карточку внутри контейнера
            const className = `${GLOBAL_STYLE_CONFIG.splitByPrefix('product-item')}`;
            const card = container.querySelector(`.${className}`);
            const cardWidth = card?.getBoundingClientRect().width ?? 0;

            setCount(Math.floor(containerWidth / cardWidth));
        })

        // Подписываемся на Subject -  это DOM-элемент, размер которого может измениться.
        if (containerRef?.current) observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, [])

    return count
}

export {useItemsPerRow};